import { render, staticRenderFns } from "./DiscountTable.vue?vue&type=template&id=71f6898c&scoped=true&"
import script from "./DiscountTable.vue?vue&type=script&lang=js&"
export * from "./DiscountTable.vue?vue&type=script&lang=js&"
import style0 from "./DiscountTable.vue?vue&type=style&index=0&id=71f6898c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f6898c",
  null
  
)

export default component.exports